import Avatar from '@components/v2/ui/Avatar/Avatar';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { Brand } from '../../../../context/ApplicationContext/applicationContext.types';
import { StoreConnectionsTestIds } from '../storeConnections.testIds';
import { BRAND_TILE_AVATAR_SIZE } from '../storeConnections.utils';
import BrandTile from './BrandTile';

interface BrandCardProps {
  brand: Brand;
  onClick: (brand: Brand) => void;
}

const BRAND_AVATAR_BORDER_COMPENSATION = 2;

const BrandCard = ({ brand, onClick }: BrandCardProps) => (
  <Tooltip TooltipContent={brand.name} placement="bottom" tabIndex={-1}>
    <BrandTile
      label={brand.name}
      testId={`${StoreConnectionsTestIds.BRAND_CARD_PREFIX}${brand.id}`}
      onClick={() => onClick(brand)}
    >
      <Avatar
        src={brand.logo}
        alt={brand.name}
        size={BRAND_TILE_AVATAR_SIZE + BRAND_AVATAR_BORDER_COMPENSATION}
        fallback="initials"
        initials={brand.name[0]?.toUpperCase() ?? ''}
        sx={(theme) => ({
          fontSize: BRAND_TILE_AVATAR_SIZE * 0.5,
          border: `1px solid ${theme.palette.custom.border.secondary}`,
          borderRadius: `${theme.shape.borderRadiusLg}px`,
        })}
      />
    </BrandTile>
  </Tooltip>
);

export default BrandCard;
